import React from 'react';
import styled from 'styled-components';

const TabsContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px solid #e8e8e8;
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  
  &::-webkit-scrollbar {
    height: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
`;

const Tab = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: ${props => props.active ? '#1890ff' : '#595959'};
  border-bottom: 2px solid ${props => props.active ? '#1890ff' : 'transparent'};
  transition: all 0.3s;
  
  &:hover {
    color: #40a9ff;
  }
  
  svg {
    font-size: 16px;
  }
`;

// SubTabsContainer for nested tabs with a different style
const SubTabsContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px solid #f0f0f0;
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  padding-left: 8px;
  background-color: #fafafa;
  border-radius: 4px 4px 0 0;
  
  &::-webkit-scrollbar {
    height: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
`;

const SubTab = styled.div`
  padding: 10px 14px;
  cursor: pointer;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: ${props => props.active ? '#1890ff' : '#595959'};
  border-bottom: 2px solid ${props => props.active ? '#1890ff' : 'transparent'};
  transition: all 0.3s;
  
  &:hover {
    color: #40a9ff;
  }
  
  svg {
    font-size: 14px;
  }
`;

const AdminTabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <TabsContainer>
      {tabs.map(tab => (
        <Tab 
          key={tab.id} 
          active={activeTab === tab.id} 
          onClick={() => onTabChange(tab.id)}
        >
          {tab.icon}
          {tab.label}
        </Tab>
      ))}
    </TabsContainer>
  );
};

const AdminSubTabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <SubTabsContainer>
      {tabs.map(tab => (
        <SubTab 
          key={tab.id} 
          active={activeTab === tab.id} 
          onClick={() => onTabChange(tab.id)}
        >
          {tab.icon}
          {tab.label}
        </SubTab>
      ))}
    </SubTabsContainer>
  );
};

export { AdminTabs, AdminSubTabs, TabsContainer, Tab, SubTabsContainer, SubTab };
